import { createContext } from "react";
import { subscriptionContextDefault, SubscriptionContextType } from "./subscription-types";

// Create the context with the default value imported from a separate file
export const SubscriptionContext = createContext<SubscriptionContextType>(subscriptionContextDefault);
